import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormGroup, Validators} from "@angular/forms";
import {DictionaryService} from "@amlCore/services";
import {IDictItemType} from "@amlCore/interfaces";
import {ClientTypeEnum} from "@amlCore/enums";
import {Unsubscribable} from "rxjs";
import {InternalService} from "../internal.service";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {ActivatedRoute, Router} from "@angular/router";
import {DictType} from "../../../../client/models/dossier";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";
import moment from "moment/moment";

@Component({
  selector: 'app-internal',
  templateUrl: './internal.component.html'
})
export class InternalComponent implements OnInit, OnDestroy {
  @ViewChild('alertObjSave', {static: true}) alertPanelComponent: AlertPanelComponent;
  id: string; // id записи (если есть - форма редактирования/просмотра)
  submitted = false;
  form: FormGroup;
  ClientTypeEnum = ClientTypeEnum;
  uchTypes = {
    [ClientTypeEnum.LEGAL_ENTITY]: 'ul',
    [ClientTypeEnum.INDIVIDUAL_PERSON]: 'fl',
    [ClientTypeEnum.INDIVIDUAL_ENTREPRENEUR]: 'ip',
    [ClientTypeEnum.PRIVATE_PRACTITIONER]: 'flcp',
    [ClientTypeEnum.FOREIGN_STRUCTURE]: 'inbul',
  };
  unsubList: Unsubscribable[] = [];
  clientTypeList: IDictItemType[] = [];
  docTypeList: IDictItemType[] = [];
  opfInbULList: Array<DictType> = [];
  countryList: Array<DictType> = [];
  regionList: Array<DictType> = [];
  goBack = Utils.goBack;
  isOrgNameReq = false; // Признак обязательности поле orgName
  orgNameUlField = ['ul.orgNameFullRu', 'ul.orgNameRu', 'ul.orgNameFullIn', 'ul.orgNameIn'];
  orgNameInbulField = ['inbul.orgNameFullRu', 'inbul.orgNameRu', 'inbul.orgNameFullIn', 'inbul.orgNameIn'];

  constructor(private dictSrv: DictionaryService,
              private internalService: InternalService,
              private alertPanelSrv: AlertPanelService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private fSaver: FileSaverService) {
  }

  ngOnInit(): void {
    this.initForm(); // Создаем форму
    this.initDict(); // Подгружаем справочники
    this.initData(); // Получаем данные
    this.initSub(); // Устанавливаем подписки
  }

  /**
   * Инициализация формы
   */
  private initForm(): void {
    this.form = this.internalService.getForm();
  }

  /**
   * Инициализация справочников
   */
  private initDict(): void {
    this.dictSrv.loadTypeClient().then(result => {
      this.clientTypeList = result.filter((item: IDictItemType) => !['0', '6'].includes(item.code));
    });
    this.dictSrv.getRemoteData('documenttypecodes').then((result) => {
      this.docTypeList = result;
    });
    this.dictSrv.getRemoteData("orgforminboul").then((list) => {
      this.opfInbULList = list;
    });
    this.dictSrv.getRemoteData("oksm").then((list) => {
      this.countryList = list;
    });
    this.dictSrv.getRemoteData("fiasregion").then((list) => {
      this.regionList = list;
    });
  }

  /**
   * Инициализация подписок
   */
  private initSub(): void {
    const unsub = this.f('uchType').valueChanges.subscribe(uchType => {
      this.initUchType(uchType);
    });
    this.unsubList.push(unsub);
    this.initUchType(this.f('uchType').value);
    this.orgNameUlField.forEach(field => {
      const sub = this.f(field).valueChanges.subscribe(filed => {
        this.initOrgName(this.orgNameUlField);
      });
      this.unsubList.push(sub);
    });
    this.orgNameInbulField.forEach(field => {
      const sub = this.f(field).valueChanges.subscribe(filed => {
        this.initOrgName(this.orgNameInbulField);
      });
      this.unsubList.push(sub);
    });
    const opfValueChanges = this.f('inbul.opf').valueChanges.subscribe(val => {
      this.initOpf(val);
    });
    this.unsubList.push(opfValueChanges);
  }

  /**
   * Инициализация данных
   */
  private initData(): void {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id) {
      this.internalService.getInternal(this.id).subscribe(data => {
        if (data.uchType) {
          let {uchType, active, adress, ...uchData} = data;
          const value = {
            uchType: data.uchType,
            active: data.active,
            [this.uchTypes[data.uchType]]: uchData,
            adress: data.adress || {},
          };
          this.form.patchValue(value);
          this.initOpf(this.f('inbul.opf').value);
          this.form.markAsPristine();
        }
      });
    }
  }

  initOpf(value): void {
    if (!this.f('inbul').disabled) {
      const iof = this.f('inbul.iof');
      iof.disable();
      if (value === "4") {
        iof.setValidators(Validators.required);
        iof.enable();
      }
      this.form.updateValueAndValidity();
    }
  }


  initOrgName(fileds: string[]): void {
    this.isOrgNameReq = true;
    fileds.forEach(field => {
      const value = this.f(field).value;
      if (value && value !== "") {
        this.isOrgNameReq = false;
      }
    });
  }

  /**
   * Инициализация типа лица
   * открыти/скрытия части полей
   * @param uchType - тип лица
   */
  initUchType(uchType: ClientTypeEnum): void {
    Object.keys(this.uchTypes).forEach(key => {
      if (uchType && uchType === key) {
        this.f(this.uchTypes[key]).enable();
      } else {
        this.f(this.uchTypes[key]).disable();
      }
    });
    if(uchType && !this.id) {
      const createdField = this.f(`${this.uchTypes[uchType]}.created`);
      if(!createdField.value){
        createdField.setValue(moment(Date.now()).format( "DD.MM.YYYY"));
      }
    }
  }

  /**
   * Сохранение
   */
  save(): void {
    if (this.form.invalid) {
      this.submitted = true;
      this.alertPanelComponent.open(this.alertPanelSrv.getErrorMsg('Необходимо заполнить обязательные поля'));
      return;
    }
    const value = this.form.value;
    const uchTypeName = this.uchTypes[value.uchType];
    // подставляем данные по лицу
    const valueFromSave = Object.assign(value, value[uchTypeName]);
    // удаляем не нужные данные
    delete valueFromSave[uchTypeName];
    if (this.id) {
      valueFromSave.id = this.id;
    }
    this.internalService.saveInternal(value).subscribe(data => {
      if(data === 409){
        const modal = this.modalService.open(ConfirmComponent);
        modal.componentInstance.title = "Внимание";
        modal.componentInstance.text = "Клиент уже зарегистрирован в клиентской базе. Сохранение невозможно. Совпадающие значения будут выведены в отчет.";
        modal.componentInstance.okBtn = "Ок";
        modal.componentInstance.cancelBtn = "Отмена";
        modal.componentInstance.hideCloseBtn = true;
        modal.result.then(() => {
          this.internalService.downloadUniqueReport(value).subscribe(data => {
            if (data.type === 4) {
              this.fSaver.save(data.body, Utils.getFileNameFromContentDisposition(data));
            }
          });
        }, () => {});
      } else if (!this.id) {
        this.router.navigate(['/registries/internal', data.id], {replaceUrl: true});
      } else {
        this.form.markAsPristine();
        this.alertPanelComponent.open(this.alertPanelSrv.getSuccessMsg('Данные успешно сохранены'));
      }
    });
  }

  onChangeData(fieldPath: string): void {
    if (this.f(fieldPath).value === '') {
      this.f(fieldPath).setValue(null);
    }
  }

  f(field: string) {
    return this.form.get(field);
  }

  fAddr(field: string) {
    return this.form.get(`adress.${field}`);
  }



  ngOnDestroy(): void {
    this.unsubList.forEach(sub => sub.unsubscribe());
  }
}
